import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

// Modale bloccante mostrato quando l'utente deve cambiare la password al primo accesso.
export function ForcePasswordChange() {
  const { user, refresh } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  if (!(user && user.must_change_password) || user.impersonating) return null;

  const submit = async () => {
    if (next.length < 6) { toast.error("La nuova password deve avere almeno 6 caratteri"); return; }
    setBusy(true);
    try {
      await api.post("/account/password", { current_password: current, new_password: next });
      toast.success("Password aggiornata");
      await refresh();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={true}>
      <DialogContent className="[&>button]:hidden" data-testid="force-password-change">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-primary" /> Cambia la password</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Per motivi di sicurezza devi impostare una nuova password prima di continuare.</p>
        <div className="space-y-3 mt-2">
          <div><Label>Password attuale (temporanea)</Label><Input type="password" className="mt-1.5" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="force-current" /></div>
          <div><Label>Nuova password</Label><Input type="password" className="mt-1.5" value={next} onChange={(e) => setNext(e.target.value)} data-testid="force-new" /></div>
          <Button className="w-full" disabled={busy || !current || next.length < 6} onClick={submit} data-testid="force-save">{busy ? "Salvataggio…" : "Aggiorna password"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
